(() => {
  const vehicleKey = 'filter.p.m.organizer.car_models';
  const previewKeys = ['preview_theme_id', '_fd', 'pb', 'filter.p.m.organizer.product_brand'];
  function init() {
    // Keep the preferred heading placement, with the same menu available while scrolling.
    const heading = document.querySelector('.njd-title-row,.njs-heading-row,.njt-wheels__collection-heading');
    const menu = document.querySelector('.njd-toolbar>njt-parts-menu,.njs-toolbar>njt-parts-menu,.njt-wheels__toolbar>njt-parts-menu');
    if (heading && menu && !heading.querySelector('[data-njt-parts-heading]')) {
      const trigger = menu.querySelector('.njp-trigger');
      const proxy = trigger.cloneNode(true);
      proxy.dataset.njtPartsHeading = '';
      proxy.addEventListener('click', () => trigger.click());
      heading.append(proxy);
      const syncExpanded = () => proxy.setAttribute('aria-expanded', trigger.getAttribute('aria-expanded') || 'false');
      new MutationObserver(syncExpanded).observe(trigger, {attributes:true,attributeFilter:['aria-expanded']});
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => {
          const above = entries[0].boundingClientRect.bottom <= 0;
          menu.classList.toggle('njt-parts-in-heading', !above);
          // Never hide the focused control while a menu is open.
        }, {threshold:0}).observe(heading);
      }
      menu.addEventListener('close', () => {
        if (menu.classList.contains('njt-parts-in-heading')) proxy.focus({preventScroll:true});
      }, true);
    }
    document.querySelectorAll('.njd-more,.njs-more,.njt-wheels__more-parts').forEach(menu => {
      if (menu.dataset.hoverReady) return;
      menu.dataset.hoverReady = 'true';
      let timer;
      const hover = () => matchMedia('(hover: hover) and (pointer: fine)').matches;
      menu.addEventListener('pointerenter', () => { if (hover()) { clearTimeout(timer); menu.open = true; } });
      menu.addEventListener('pointerleave', () => { if (hover()) timer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 220); });
      menu.addEventListener('keydown', e => { if (e.key === 'Escape') { clearTimeout(timer); menu.open = false; menu.querySelector('summary').focus(); } });
      menu.addEventListener('focusout', () => { setTimeout(() => { if (!menu.contains(document.activeElement) && !menu.matches(':hover')) menu.open = false; }, 0); });
      document.addEventListener('pointerdown', e => { if (menu.open && !menu.contains(e.target)) { clearTimeout(timer); menu.open = false; } });
    });
    const current = new URL(location.href);
    const carry = target => {
      [vehicleKey, ...previewKeys].forEach(key => {
        if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
      });
      return target;
    };
    document.querySelectorAll('[data-njd-category],[data-njd-reset]').forEach(a => {
      const target = new URL(a.href); target.search = ''; a.href = carry(target).href;
    });
    const form = document.querySelector('.njd-form');
    const home = document.querySelector('[data-njd-filter-home]');
    const dialog = document.querySelector('.njd-dialog');
    const open = document.querySelector('[data-njd-open]');
    if (!form || !dialog || !open) return;
    [vehicleKey, ...previewKeys].forEach(key => {
      if (current.searchParams.has(key) && !form.elements.namedItem(key)) {
        const input = document.createElement('input'); input.type = 'hidden'; input.name = key; input.value = current.searchParams.get(key); form.append(input);
      }
    });
    open.addEventListener('click', () => {dialog.querySelector('[data-njd-filter-body]').append(form); dialog.showModal(); document.documentElement.classList.add('njd-modal-open');});
    dialog.querySelector('[data-njd-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {home.append(form); document.documentElement.classList.remove('njd-modal-open'); open.focus({preventScroll:true});});
    form.addEventListener('change', e => {
      if (e.target.matches('input[type=checkbox], input[type=number], select')) form.requestSubmit();
    });
    form.addEventListener('submit', e => {
      e.preventDefault(); const target = new URL(form.action); const data = new FormData(form);
      for (const [key,value] of data) if (value !== '') target.searchParams.append(key,value);
      location.assign(carry(target).href);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
